
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ObjectInfoTitle from '../ObjectInfoTitle';
import IsknOpsubInfo from './IsknOpsubInfo';
import IsknParList from './IsknParList';
import IsknTelList from './IsknTelList';

const IsknOpsubObject = ({isknDate, objectInfo}) => {

    return (
        <Stack tokens={{childrenGap: 16}}>
            <Stack.Item>
                <ObjectInfoTitle title="VLASTNÍK" />
                <IsknOpsubInfo
                    data={objectInfo}
                    isknDate={isknDate}
                />
            </Stack.Item>
            <Stack.Item>
                <ObjectInfoTitle title="LIST VLASTNICTVÍ" />
                <IsknTelList
                    compact={true}
                    data={objectInfo}
                    isknDate={isknDate}
                />
            </Stack.Item>
            <Stack.Item>
                <ObjectInfoTitle title="PARCELY" />
                <IsknParList
                    compact={true}
                    data={objectInfo}
                    isknDate={isknDate}
                />
            </Stack.Item>
        </Stack>
    );
}

export default IsknOpsubObject;
